var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"iv-main-hover-color iv-main-color iv-pointer iv-operate-item iv-pull-left uit-editor-list iv-fs-14",on:{"click":function($event){return _vm.operateClick(_vm.item, 'see')}}},[_vm._v(_vm._s('查看详情'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }